import React from 'react';
import { Card, Form, Row, Col } from 'react-bootstrap';

const VenueManagement = ({ formData, handleFormChange }) => {
  return (
    <Card className="dark-main-card text-light">
      <Card.Body className="p-4 compact-form">
        <h3 className="mb-4 text-white" style={{ fontSize: "1.5rem" }}>Venue Management</h3>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="venueType">
              <Form.Label>Venue Type</Form.Label>
              <Form.Control
                as="select"
                multiple
                name="venueType"
                value={formData.venueType}
                onChange={handleFormChange}
                className="dark-input"
              >
                <option value="indoor">Indoor</option>
                <option value="outdoor">Outdoor</option>
                <option value="hybrid">Hybrid</option>
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3" controlId="minimumCapacity">
              <Form.Label>Minimum Capacity</Form.Label>
              <Form.Control
                type="number"
                name="minimumCapacity"
                value={formData.minimumCapacity}
                onChange={handleFormChange}
                className="dark-input"
              />
            </Form.Group>
          </Col>
        </Row>
        <Form.Group className="mb-3" controlId="requiredAmenities">
          <Form.Label>Required Amenities</Form.Label>
          <Form.Control
            as="select"
            multiple
            name="requiredAmenities"
            value={formData.requiredAmenities}
            onChange={handleFormChange}
            className="dark-input"
          >
            <option value="parking">Parking</option>
            <option value="avSystem">AV System</option>
            <option value="cateringFacilities">Catering Facilities</option>
          </Form.Control>
        </Form.Group>
        <Form.Group className="mb-3" controlId="locationPreferences">
          <Form.Label>Location Preferences</Form.Label>
          <Form.Control
            type="text"
            name="locationPreferences"
            value={formData.locationPreferences}
            onChange={handleFormChange}
            className="dark-input"
          />
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default VenueManagement;